import React, { useState, useEffect } from 'react'
import { Container, Table, TableHeader, TableHeaderCell, TableBody, TableRow, TableCell, Icon } from 'semantic-ui-react'

const Packages = ({ savedDict, packageClicked, hasPackages }) => {
    const [packages, setPackages] = useState([])

    useEffect(() => {
        if (savedDict) {
            setPackages(savedDict.packages || [])
        }
    }, [savedDict])

    if (!hasPackages) return <h3 style={{ marginTop: 35 }}>Packages not applicable, use Merchandise instead.</h3>

    const renderTableRows = () => {
        if (!packages) return null
        const rows = []
        for (const [i, pkg] of packages.entries()) {
            rows.push(
                <TableRow key={i} style={{ cursor: 'pointer' }} onClick={() => packageClicked(i)}>
                    <TableCell>{pkg.name}</TableCell>
                    <TableCell>{pkg.supplierPackageName}</TableCell>
                    <TableCell>{pkg.gameItems.length}</TableCell>
                    <TableCell textAlign='center'>{pkg.isOutOfStock ? <Icon color='green' name='checkmark' size='large' /> : '-'}</TableCell>
                </TableRow>
            )
        }
        return rows
    }

    const renderTable = () => {
        if (!packages) {
            return <h4 style={{ color: 'white' }}>This game has no packages.</h4>
        } else {
            return (
                <Table celled inverted>
                    <TableHeader>
                        <TableRow>
                            <TableHeaderCell>Name</TableHeaderCell>
                            <TableHeaderCell>Supplier Name</TableHeaderCell>
                            <TableHeaderCell width='2'>Item Count</TableHeaderCell>
                            <TableHeaderCell width='2' textAlign='center'>Is Out of Stock</TableHeaderCell>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {renderTableRows()}
                    </TableBody>
                </Table>
            )
        }
    }

    return (
        <Container inverted style={{ background: '#1b1c1d', padding: '20px' }}>
            {renderTable()}
        </Container>
    )
}

export default Packages